import React, { useState } from 'react';
import { login, getUserRole } from './auth';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const data = await login(email, password);

            if (data.success) {
                toast.success('Login successfully!');

                const userRole = data.role;

                // Redirect based on role
                if (userRole === 'admin') {
                    navigate('/admin/dashboard');
                }

                else {
                    toast.error('Invalid role. Contact admin.');
                }
            } else {
                toast.error(data.message || 'Login failed');
            }
        } catch (error) {
            toast.error(error.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="app">
                <div className="app-wrap">
                    <div className="app-contant">
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                                minHeight: "100vh",
                                backgroundColor: "#f0f9ff"
                            }}
                        >
                            <div className="login p-5 shadow rounded" style={{ maxWidth: '400px', width: '100%', background: 'white' }}>
                                <div className="text-center mb-4">

                                    <img src={`${process.env.PUBLIC_URL}/logo.png`} />

                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Email Address</label>
                                        <div className="input-group">
                                            <span className="input-group-text">
                                                <i className="fas fa-envelope"></i>
                                            </span>
                                            <input
                                                type="email"
                                                className="form-control"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder="Enter email"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Password</label>
                                        <div className="input-group">
                                            <span className="input-group-text">
                                                <i className="fas fa-lock"></i>
                                            </span>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder="Enter password"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <button
                                        className="btn btn-primary w-100 py-2"
                                        type="submit"
                                        disabled={loading}
                                        style={{ background: '#0b2b3b', border: 'none' }}
                                    >
                                        {loading ? (
                                            <>
                                                <i className="fas fa-spinner fa-spin me-2"></i> Logging in...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-sign-in-alt me-2"></i> Login
                                            </>
                                        )}
                                    </button>
                                </form>

                                {/* <div className="mt-4 text-center">
                                    <small className="text-muted">Demo Credentials:</small>
                                    <div className="mt-2 small">
                                        <div><strong>Admin:</strong> admin@admin.com / password</div>
                                        <div><strong>Manager:</strong> manager@manager.com / password</div>
                                        <div><strong>Cashier:</strong> cashier@cashier.com / password</div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </>
    );
};

export default Login;